import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e7947be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }

import OfficeAssetTaskList from "@/views/ViewsComponents/officeAssets/OfficeAssetTaskList.vue";
import {reactive} from "vue";
import OfficeAssetTaskDetail from "@/views/ViewsComponents/officeAssets/OfficeAssetTaskDetail.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const pageInfo = reactive<{
  showDetail: boolean,
  task: any
}>({
  showDetail: false,
  task: null
})
const showDetail = (task: any) => {
  pageInfo.task = task
  pageInfo.showDetail = true
}

return (_ctx: any,_cache: any) => {
  const _component_el_collapse_transition = _resolveComponent("el-collapse-transition")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_collapse_transition, null, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(OfficeAssetTaskDetail, {
          show: _unref(pageInfo).showDetail,
          task: _unref(pageInfo).task,
          onBack: _cache[0] || (_cache[0] = ($event: any) => (_unref(pageInfo).showDetail=false))
        }, null, 8, ["show", "task"]), [
          [_vShow, _unref(pageInfo).showDetail]
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_el_collapse_transition, null, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(OfficeAssetTaskList, { onShowDetail: showDetail }, null, 512), [
          [_vShow, !_unref(pageInfo).showDetail]
        ])
      ]),
      _: 1
    })
  ]))
}
}

})